import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useAuth = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const expiration = Number(localStorage.getItem("expiration"));

    if (!token || !expiration || expiration <= Date.now()) {
      navigate("/login");
    }
  }, [navigate]);
};

export default useAuth;
